import { bindable, computedFrom } from 'aurelia-framework';

export class LimitText {
	@bindable text: string;
	@bindable limit: number;

	@computedFrom('text')
	get limitedText() {
		if (!this.limit || !this.text) { return this.text; }
		if (this.text.length <= this.limit) { return this.text; }
		return this.text.slice(0, this.limit - 3) + '...';
	}
}
